'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Content-module_content__dii8H{align-self:flex-start;grid-column:span 12}";
var styles = {"content":"Content-module_content__dii8H"};
styleInject["default"](css_248z, 'cbb66b05-daaa-40dd-9ae9-35870d3c8bd6');

exports["default"] = styles;
